export enum PageType {
  MegaMap,
  LandingPage,
  SocialMediaCampaign,
  IFrame,
  ProductRecommendation,
  ChatBot,
  CallCenter,
  CallCenterRalph,
  RetailCallCenter,
  RetailCohortAnalysis,
  RetailFormRecognizer,
  RetailIncidentInsights,
  HealthCareContactCenter,
  HealthCareFormRecognizer,
  HealthCareClinicalNotes,
  HealthCareHospitalIncidentInsights,
  HealthCareCohortAnalysis,
  CohortAnalysis,
  TextAnalytics,
  FormRecognizer,
  SmartFactory,
  FlorenceModel,
  AzureGeoSpatialForFSI,
  FSICEODashboard,
  GeoSpatialReport,
  Disclaimer,
  HealthCareArchitecture,
  ManufacturingArchitecture,
  FSIArchitecture,
  SustainabilityArchitecture,
  PublicFinanceArchitecture,
  DatameshArchitecture,
  Retail2Architecture,
  MGDCArchitecture,
  AnalyticsInMIDPArchitecture,
  SQLMigrationArchitecture,
  PowerBIDifferentiatorsArchitecture,
  MediaArchitecture,
  EndToEndPerformanceMonitoring,
  PowerBIWithAzureSynapseAnalyticsServerlessSQLPool,
  AzureSynapseDataExplorer,
  CommunicationAnalytics,
  RowlevelSecurity,
  ColumnlevelSecurity,
  DynamicDataMasking,
  SentimentAnalytics,
  RealTimeInStoreAnalytics,
  HOFHTAPReport,
  WithoutHTAP,
  WithHTAP,
  HTAP,
  CampaignAnalytics,
  CampaignAndSalesData,
  LowCodeDatamart,
  DataSecurity,
  DeploymentPipelines,
  ESGDashboard,
  WorldMap,
  CityView,
  ORGChart,
  FinaleVideo,
  CEODashboardAfter,
  CEODashboardBefore,
  CallCenterBeforeScript,
  CallCenterBeforeSummary,
  CallCenterAfterSummary,
  CallCenterAfterScript,
}
